import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/users")({
  head: () => ({ meta: [{ title: "Users | Admin" }] }),
  component: lazyRouteComponent(() => import("@/pages-lazy/admin-users")),
});
